"use client";

import { useRouter } from "@i18n/next";
import { useLocalStorageState } from "@packages/sdk";
import { useEffect } from "react";

import { LoadingPage } from "../../../components";

type ClientRedirectProps = {
  currentTranslation?: string;
  currentCategory?: string;
};

export const BibleRedirect = ({
  currentTranslation,
  currentCategory,
}: ClientRedirectProps) => {
  const [category, setCategory] = useLocalStorageState({
    key: "bibleCategory",
    defaultValue: "daily-readings",
  });
  const [translation, setTranslation] = useLocalStorageState({
    key: "bibleTranslation",
    defaultValue: "NRSV",
  });
  const [lastPage] = useLocalStorageState({
    key: "biblePage",
    defaultValue: "Gen/1",
  });

  const router = useRouter();

  useEffect(() => {
    if (!!currentCategory) setCategory(currentCategory);
    if (!!currentTranslation) setTranslation(currentTranslation);
  }, [currentCategory, currentTranslation]);

  useEffect(() => {
    if (router && category && lastPage && translation) {
      if ((currentCategory ?? category) === "daily-readings") {
        router.replace("/bible/daily-readings");
      } else if (lastPage && (translation || currentTranslation)) {
        router.replace(
          `/bible/${currentTranslation ?? translation}/${lastPage}`,
        );
      }
    }
  }, [
    router,
    category,
    lastPage,
    translation,
    currentTranslation,
    currentCategory,
  ]);

  return <LoadingPage />;
};
